import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Icon,
  Dropdown,
  Menu,
  Modal,
  Button,
  Badge,
  Row,
  Col,
  Card,
  Statistic,
  Tooltip,
  Select,
  Input,
  Popover,
  Divider,
  Checkbox,
  Skeleton,
  Drawer
} from 'antd';
import { compare } from 'natural-orderby';
import moment from 'moment';
import FileDownload from 'js-file-download';

import Archive from './Includes/Archive';
import { toBRL } from '../UI/InputCurrency';
import { ModuleHeader, ModuleHeaderWrapper } from '../ModuleHeader';
import DateNavigation from '~/_shared/components/DateNavigation';
import CertificatesTableList from './Components/TableList';
import SelectionToolbar from '~/_shared/components/SelectionToolbar';
import StatTooltip from '~/_shared/components/StatTooltip';
import FilterPillsBar from '~/_shared/components/FilterPillsBar';
import { request } from '../Instance';
import RestoredFiltersNotice from '~/_shared/components/RestoredFiltersNotice';
import {
  isYearApplied,
  getVisualizationChange,
  countActiveCertificatesFilters,
  getFilterByLabel,
} from './filters';

var Option = Select.Option;

var fmtBRL = function(v) { return toBRL(v != null ? v : 0); };

class CertificatesList extends Component {

    // Filters (visualization, sub-filters, search, year, filter by) live in
    // props.persisted (usePersistedFilters in the screen), so they survive a refresh.
    state = {
      archive: null,
      selectedRowKeys: [],
      pendentBannerDismissed: false,
      pendentDrawerVisible: false,
    }

  applyFilters = function(changes) {
    var persisted = this.props.persisted;
    var next = changes;
    if (changes.visualizationMode && changes.visualizationMode !== persisted.filters.visualizationMode) {
      next = Object.assign({}, changes, getVisualizationChange(persisted.filters, changes.visualizationMode));
      this.setState({ selectedRowKeys: [] });
    }
    persisted.setFilters(next);
  }.bind(this)

  // Year from DateNavigation ('YYYY-MM'). Without a "filtrar por" the year is not
  // applied, so picking one turns the default date field back on.
  handleYearChange = function(newDate) {
    var persisted = this.props.persisted;
    var changes = { year: String(newDate).slice(0, 4) };
    if (!persisted.filters.filterBy) changes.filterBy = persisted.defaults.filterBy;
    persisted.setFilters(changes);
  }.bind(this)

  handleClearFilters = function() {
    this.setState({ selectedRowKeys: [] });
    this.props.persisted.resetFilters();
  }.bind(this)

  onAction = function(e, certificate) {
    switch (e.key) {
      case 'edit':
        this.props.showEdit(certificate);
        break;
      case 'archive':
        this.setState({ archive: certificate });
        break;
      case 'unArchive':
        Modal.confirm({
          title: 'Voce realmente deseja desarquivar este certificado?',
          content: 'Voce podera arquivar este certificado novamente no futuro',
          okText: 'Sim',
          okType: 'danger',
          cancelText: 'Cancelar',
          onOk: function() { this.props.unArchive(certificate.id); }.bind(this)
        });
        break;
      case 'delete':
        Modal.confirm({
          title: 'Voce realmente deseja excluir este certificado?',
          content: 'Esta acao nao podera ser desfeita.',
          okText: 'Sim',
          okType: 'danger',
          cancelText: 'Cancelar',
          onOk: function() { this.props.deleteCertificate(certificate.id); }.bind(this)
        });
        break;
    }
  }.bind(this)

  getFilename = function(certificate) {
    return (certificate.customer_name || 'certificado') + '_CERTIFICADO_' + moment().format('DD-MM-YYYY') + '.pdf';
  }

  onSelectedRowKeysChange = function(selectedRowKeys) {
    this.setState({ selectedRowKeys: selectedRowKeys });
  }.bind(this)

  handleClearSelection = function() {
    this.setState({ selectedRowKeys: [] });
  }.bind(this)

  exportToExcel = function() {
    var ids = this.state.selectedRowKeys;
    var filterData = ids.length > 0
      ? { ids: ids }
      : {};

    request(
      "POST",
      "certificates/export/excel",
      filterData,
      true,
      { responseType: 'blob' }
    )
    .then(function(response) {
        var now = moment().format('YYYY-MM-DD_hh-mm-ss');
        FileDownload(response.data, 'Certificados_' + now + '.xlsx');
    });
  }.bind(this)

  handleBulkPrint = function() {
    var ids = this.state.selectedRowKeys;
    request(
      "POST",
      "certificates/print/batch",
      { ids: ids },
      true,
      { responseType: ids.length <= 10 ? 'blob' : 'json' }
    )
    .then(function(response) {
      if (ids.length <= 10) {
        FileDownload(response.data, 'certificados.zip');
      } else {
        Modal.success({ title: 'Arquivo em processamento', content: 'O arquivo sera enviado por e-mail quando estiver pronto.' });
      }
    });
  }.bind(this)

  computeStats = function(certs) {
    var totalCount = certs.length;
    var activeCount = 0;
    var expiringCount = 0;
    var expiredCount = 0;
    var totalAmount = 0;
    var totalFaturado = 0;
    var totalRecebido = 0;
    var totalPendente = 0;
    var ecpfA1 = 0;
    var ecpfA3 = 0;
    var ecnpjA1 = 0;
    var ecnpjA3 = 0;
    var pfCount = 0;
    var pjCount = 0;

    for (var i = 0; i < totalCount; i++) {
      var c = certs[i];
      if (c.state === 'Ativo') activeCount++;
      if (c.state === 'Expirando') expiringCount++;
      if (c.state === 'Expirado') expiredCount++;
      totalAmount += parseFloat(c.amount) || 0;
      totalFaturado += parseFloat(c.extras_total) || 0;
      totalRecebido += parseFloat(c.extras_paid) || 0;
      totalPendente += parseFloat(c.extras_pending) || 0;
      if (c.type === 'E-CPF A1') ecpfA1++;
      if (c.type === 'E-CPF A3') ecpfA3++;
      if (c.type === 'E-CNPJ A1') ecnpjA1++;
      if (c.type === 'E-CNPJ A3') ecnpjA3++;
      if (c.nature === 'PF') pfCount++;
      if (c.nature === 'PJ') pjCount++;
    }

    return {
      totalCount: totalCount,
      activeCount: activeCount,
      expiringCount: expiringCount,
      expiredCount: expiredCount,
      totalAmount: totalAmount,
      totalFaturado: totalFaturado,
      totalRecebido: totalRecebido,
      totalPendente: totalPendente,
      ecpfA1: ecpfA1,
      ecpfA3: ecpfA3,
      ecnpjA1: ecnpjA1,
      ecnpjA3: ecnpjA3,
      pfCount: pfCount,
      pjCount: pjCount,
    };
  }

  render() {
    var persisted = this.props.persisted;
    var filters = persisted.filters;
    var defaults = persisted.defaults;
    var visualizationMode = filters.visualizationMode;
    var search = filters.search || '';
    var selectedRowKeys = this.state.selectedRowKeys;
    var findUser = this.props.findUser;
    var isLoading = this.props.isLoading;

    var formattedCertificates = this.props.certificates && this.props.customers ? this.props.certificates.map(function(item) {
      return Object.assign({}, item, {
        name: (!!item.customer_name && item.nature === 'PJ') ? item.customer_name : item.owner_name,
      });
    }) : [];

    var searchLower = search.toLowerCase();
    var filteredCertificates = (formattedCertificates !== null) ? formattedCertificates.filter(function(str) {
      if (str.name && str.name.toLowerCase().indexOf(searchLower) >= 0) {
        return true;
      }
      if (str.customer_cod && str.customer_cod.toLowerCase().indexOf(searchLower) >= 0) {
        return true;
      }
      return false;
    }) : [];

    var certificates = {
      archived: filteredCertificates.filter(function(c) { return c.state === 'Arquivado'; }),
      pendent: filteredCertificates.filter(function(c) { return c.status === 'pendent' && c.state !== 'Arquivado'; }),
      registered: filteredCertificates.filter(function(c) { return c.status === 'registered' && c.state !== 'Arquivado'; })
    };

    var activeData = certificates[visualizationMode] || [];

    var statusFilters = filters.statusFilters || [];
    var typeFilters = filters.typeFilters || [];
    var natureFilters = filters.natureFilters || [];
    var hasSubFilters = statusFilters.length > 0 || typeFilters.length > 0 || natureFilters.length > 0;

    var displayData = activeData;
    if (hasSubFilters) {
      displayData = activeData.filter(function(c) {
        if (statusFilters.length > 0 && statusFilters.indexOf(c.state) === -1) return false;
        if (typeFilters.length > 0 && typeFilters.indexOf(c.type) === -1) return false;
        if (natureFilters.length > 0 && natureFilters.indexOf(c.nature) === -1) return false;
        return true;
      });
    }

    // Stats reflect what the user sees (displayData), counts use activeData for filter pill badges
    var stats = this.computeStats(displayData);

    var statusCounts = { Ativo: 0, Expirando: 0, Expirado: 0 };
    var typeCounts = { 'E-CPF A1': 0, 'E-CPF A3': 0, 'E-CNPJ A1': 0, 'E-CNPJ A3': 0 };
    var natureCounts = { PF: 0, PJ: 0 };
    for (var ci = 0; ci < activeData.length; ci++) {
      var ce = activeData[ci];
      if (statusCounts[ce.state] !== undefined) statusCounts[ce.state]++;
      if (typeCounts[ce.type] !== undefined) typeCounts[ce.type]++;
      if (natureCounts[ce.nature] !== undefined) natureCounts[ce.nature]++;
    }

    // Badge: only what differs from the defaults (due date + current year don't count).
    var filterCount = countActiveCertificatesFilters(filters, defaults);

    var totalTooltip = (
      <StatTooltip
        title="Resumo Total"
        rows={[
          { label: 'Total', value: stats.totalCount + ' certificados' },
          { label: 'E-CPF A1', value: stats.ecpfA1 + '' },
          { label: 'E-CPF A3', value: stats.ecpfA3 + '' },
          { label: 'E-CNPJ A1', value: stats.ecnpjA1 + '' },
          { label: 'E-CNPJ A3', value: stats.ecnpjA3 + '' },
          { label: 'PF', value: stats.pfCount + '', borderTop: true },
          { label: 'PJ', value: stats.pjCount + '' },
        ]}
      />
    );

    var statusTooltip = (
      <StatTooltip
        title="Status dos Certificados"
        rows={[
          { label: 'Ativos', value: stats.activeCount + '', color: '#95de64' },
          { label: 'Expirando', value: stats.expiringCount + '', color: '#ffc53d' },
          { label: 'Expirados', value: stats.expiredCount + '', color: '#ff7875' },
          { label: 'Total', value: stats.totalCount + '', bold: true, borderTop: true },
        ]}
        description="Ativos: mais de 30 dias. Expirando: proximos 30 dias. Expirados: vencidos."
      />
    );

    var financeTooltip = (
      <StatTooltip
        title="Financeiro Vinculado"
        rows={[
          { label: 'Faturado', value: 'R$ ' + fmtBRL(stats.totalFaturado), color: '#69c0ff' },
          { label: 'Recebido', value: 'R$ ' + fmtBRL(stats.totalRecebido), color: '#95de64' },
          { label: 'Pendente', value: 'R$ ' + fmtBRL(stats.totalPendente), bold: true, borderTop: true, color: '#ffc53d' },
        ]}
      />
    );

    return (
      <div>
        {this.state.archive !== null && (
          <Archive
            data={this.state.archive}
            onClose={function() { this.setState({ archive: null }); }.bind(this)}
            saveCertificate={this.props.saveCertificate}
          />
        )}
        <ModuleHeaderWrapper>
          <ModuleHeader
            breadcrumbs={['Dep. Societario', 'Certificados digitais']}
            title="Certificados Digitais"
            search={
              <Input
                prefix={<Icon type="search" style={{ color: '#bfbfbf' }} />}
                value={search}
                placeholder="Pesquisar"
                allowClear
                onChange={function(e) { persisted.setFilters({ search: e.target.value }); }}
                onKeyDown={function(e) { if (e.key === 'Escape') { persisted.setFilters({ search: '' }); e.target.blur(); } }}
                style={{ width: 240, borderRadius: 8 }}
              />
            }
            center={
              <>
                <Popover
                  trigger="click"
                  placement="bottomRight"
                  content={
                    <div style={{ width: 560 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                        <span style={{ fontSize: 15, fontWeight: 600, color: '#262626' }}>Filtros</span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                          {filterCount > 0 && (
                            <a
                              style={{ fontSize: 12, color: '#f5222d' }}
                              onClick={this.handleClearFilters}
                            >
                              Limpar tudo
                            </a>
                          )}
                          <DateNavigation
                            date={filters.year + '-' + moment().format('MM')}
                            onChange={this.handleYearChange}
                            mode="year"
                          />
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: 20 }}>
                        {/* Column 1: Visualização */}
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 11, color: '#8c8c8c', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Visualização</div>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 14 }}>
                            {[
                              { value: 'registered', label: 'Cadastrados', count: certificates.registered.length, color: '#1890ff' },
                              { value: 'archived', label: 'Arquivados', count: certificates.archived.length, color: '#8c8c8c', icon: 'inbox' },
                            ].map(function(opt) {
                              var isActive = visualizationMode === opt.value;
                              return (
                                <div
                                  key={opt.value}
                                  onClick={function() { this.applyFilters({ visualizationMode: opt.value }); }.bind(this)}
                                  style={{
                                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                    padding: '6px 10px', borderRadius: 6, cursor: 'pointer',
                                    border: '1.5px solid ' + (isActive ? opt.color : '#e8e8e8'),
                                    background: isActive ? opt.color + '0a' : '#fafafa',
                                    transition: 'all 0.2s',
                                  }}
                                >
                                  <span style={{ fontSize: 12, color: isActive ? '#262626' : '#8c8c8c' }}>
                                    {opt.icon && <Icon type={opt.icon} style={{ marginRight: 4 }} />}
                                    {opt.label}
                                  </span>
                                  <span style={{ fontSize: 13, fontWeight: 600, color: isActive ? opt.color : '#bfbfbf' }}>{opt.count}</span>
                                </div>
                              );
                            }.bind(this))}
                          </div>
                          <div style={{ fontSize: 11, color: '#8c8c8c', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Filtrar por data</div>
                          <Select
                            value={filters.filterBy || undefined}
                            placeholder="Tipo de data"
                            allowClear
                            style={{ width: '100%' }}
                            onChange={function(val) { persisted.setFilters({ filterBy: val || null }); }}
                          >
                            <Option value="due_date">Vencimento</Option>
                            <Option value="emission_date">Emissão</Option>
                          </Select>
                        </div>
                        {/* Column 2: Status + Natureza */}
                        <div style={{ flex: 1 }}>
                          <div style={{ marginBottom: 14 }}>
                            <div style={{ fontSize: 11, color: '#8c8c8c', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Status</div>
                            <Checkbox.Group
                              value={statusFilters}
                              onChange={function(vals) { this.applyFilters({ statusFilters: vals }); }.bind(this)}
                            >
                              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                                {[
                                  { value: 'Ativo', color: '#52c41a' },
                                  { value: 'Expirando', color: '#faad14' },
                                  { value: 'Expirado', color: '#f5222d' },
                                ].map(function(s) {
                                  var isActive = statusFilters.indexOf(s.value) !== -1;
                                  var cnt = statusCounts[s.value] || 0;
                                  return (
                                    <label
                                      key={s.value}
                                      style={{
                                        display: 'inline-flex', alignItems: 'center', gap: 6,
                                        padding: '4px 10px', borderRadius: 16, cursor: 'pointer', fontSize: 13,
                                        background: isActive ? s.color : '#f5f5f5',
                                        color: isActive ? '#fff' : '#595959',
                                        border: '1px solid ' + (isActive ? s.color : '#e8e8e8'),
                                        transition: 'all 0.2s',
                                        opacity: cnt === 0 && !isActive ? 0.5 : 1,
                                      }}
                                    >
                                      <Checkbox value={s.value} style={{ display: 'none' }} />
                                      {!isActive && <span style={{ width: 8, height: 8, borderRadius: '50%', background: s.color, flexShrink: 0 }} />}
                                      {isActive && <Icon type="check" style={{ fontSize: 11 }} />}
                                      {s.value}
                                      <span style={{ fontSize: 11, opacity: 0.8 }}>({cnt})</span>
                                    </label>
                                  );
                                }.bind(this))}
                              </div>
                            </Checkbox.Group>
                          </div>
                          <div>
                            <div style={{ fontSize: 11, color: '#8c8c8c', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Natureza</div>
                            <Checkbox.Group
                              value={natureFilters}
                              onChange={function(vals) { this.applyFilters({ natureFilters: vals }); }.bind(this)}
                            >
                              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                                {[
                                  { value: 'PF', label: 'PF', color: '#722ed1' },
                                  { value: 'PJ', label: 'PJ', color: '#13c2c2' },
                                ].map(function(n) {
                                  var isActive = natureFilters.indexOf(n.value) !== -1;
                                  var cnt = natureCounts[n.value] || 0;
                                  return (
                                    <label
                                      key={n.value}
                                      style={{
                                        display: 'inline-flex', alignItems: 'center', gap: 6,
                                        padding: '4px 10px', borderRadius: 16, cursor: 'pointer', fontSize: 13,
                                        background: isActive ? n.color : '#f5f5f5',
                                        color: isActive ? '#fff' : '#595959',
                                        border: '1px solid ' + (isActive ? n.color : '#e8e8e8'),
                                        transition: 'all 0.2s',
                                        opacity: cnt === 0 && !isActive ? 0.5 : 1,
                                      }}
                                    >
                                      <Checkbox value={n.value} style={{ display: 'none' }} />
                                      {!isActive && <span style={{ width: 8, height: 8, borderRadius: '50%', background: n.color, flexShrink: 0 }} />}
                                      {isActive && <Icon type="check" style={{ fontSize: 11 }} />}
                                      {n.label}
                                      <span style={{ fontSize: 11, opacity: 0.8 }}>({cnt})</span>
                                    </label>
                                  );
                                }.bind(this))}
                              </div>
                            </Checkbox.Group>
                          </div>
                        </div>
                        {/* Column 3: Tipo */}
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 11, color: '#8c8c8c', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Tipo</div>
                          <Checkbox.Group
                            value={typeFilters}
                            onChange={function(vals) { this.applyFilters({ typeFilters: vals }); }.bind(this)}
                          >
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                              {[
                                { value: 'E-CPF A1', color: '#8c8c8c' },
                                { value: 'E-CPF A3', color: '#8c8c8c' },
                                { value: 'E-CNPJ A1', color: '#1890ff' },
                                { value: 'E-CNPJ A3', color: '#1890ff' },
                              ].map(function(t) {
                                var isActive = typeFilters.indexOf(t.value) !== -1;
                                var cnt = typeCounts[t.value] || 0;
                                return (
                                  <label
                                    key={t.value}
                                    style={{
                                      display: 'inline-flex', alignItems: 'center', gap: 6,
                                      padding: '4px 10px', borderRadius: 16, cursor: 'pointer', fontSize: 13,
                                      background: isActive ? t.color : '#f5f5f5',
                                      color: isActive ? '#fff' : '#595959',
                                      border: '1px solid ' + (isActive ? t.color : '#e8e8e8'),
                                      transition: 'all 0.2s',
                                      opacity: cnt === 0 && !isActive ? 0.5 : 1,
                                    }}
                                  >
                                    <Checkbox value={t.value} style={{ display: 'none' }} />
                                    {!isActive && <span style={{ width: 8, height: 8, borderRadius: '50%', background: t.color, flexShrink: 0 }} />}
                                    {isActive && <Icon type="check" style={{ fontSize: 11 }} />}
                                    {t.value}
                                    <span style={{ fontSize: 11, opacity: 0.8 }}>({cnt})</span>
                                  </label>
                                );
                              }.bind(this))}
                            </div>
                          </Checkbox.Group>
                        </div>
                      </div>
                    </div>
                  }
                >
                  <Badge
                    count={filterCount}
                    offset={[-4, 0]}
                    style={{ backgroundColor: '#722ed1' }}
                  >
                    <Button
                      icon="bars"
                      style={{ borderRadius: 8 }}
                    >
                      Filtros
                    </Button>
                  </Badge>
                </Popover>
                <Dropdown
                  overlay={
                    <Menu>
                      <Menu.Item key="new" onClick={function() { this.props.showModal(); }.bind(this)}>
                        <Icon type="plus" /> Cadastrar Certificado
                      </Menu.Item>
                      <Menu.Divider />
                      <Menu.Item key="csv" onClick={this.exportToExcel}>
                        <Icon type="file-excel" /> Exportar Excel
                      </Menu.Item>
                    </Menu>
                  }
                  trigger={["click"]}
                >
                  <Button
                    icon="plus"
                    shape="circle"
                  />
                </Dropdown>
              </>
            }
            advanced={
              (function() {
                var STATUS_COLORS = { Ativo: '#52c41a', Expirando: '#faad14', Expirado: '#f5222d' };
                var TYPE_COLORS = { 'E-CPF A1': '#8c8c8c', 'E-CPF A3': '#8c8c8c', 'E-CNPJ A1': '#1890ff', 'E-CNPJ A3': '#1890ff' };
          var NATURE_COLORS = { PF: '#722ed1', PJ: '#13c2c2' };
          var VIZ_LABELS = { registered: 'Cadastrados', archived: 'Arquivados' };
          var VIZ_COLORS = { registered: '#1890ff', archived: '#8c8c8c' };
          var pills = [];

          // Pills show what is applied: the year only when a date field is
          // selected (otherwise the server returns every year).
          if (isYearApplied(filters)) {
            pills.push({
              key: 'year', label: 'Ano: ' + filters.year, color: '#1890ff', icon: 'calendar',
              onRemove: filters.year !== defaults.year ? function() { persisted.setFilters({ year: defaults.year }); } : undefined,
            });
          }

          if (visualizationMode !== 'registered') {
            pills.push({
              key: 'viz', label: VIZ_LABELS[visualizationMode] || visualizationMode,
              color: VIZ_COLORS[visualizationMode] || '#595959',
              onRemove: function() { this.applyFilters({ visualizationMode: 'registered' }); }.bind(this),
            });
          }

          statusFilters.forEach(function(s) {
            pills.push({
              key: 'status-' + s, label: s, color: STATUS_COLORS[s] || '#1890ff',
              onRemove: function() { this.applyFilters({ statusFilters: statusFilters.filter(function(v) { return v !== s; }) }); }.bind(this),
            });
          }.bind(this));

          typeFilters.forEach(function(t) {
            pills.push({
              key: 'type-' + t, label: t, color: TYPE_COLORS[t] || '#595959',
              onRemove: function() { this.applyFilters({ typeFilters: typeFilters.filter(function(v) { return v !== t; }) }); }.bind(this),
            });
          }.bind(this));

          natureFilters.forEach(function(n) {
            pills.push({
              key: 'nature-' + n, label: n, color: NATURE_COLORS[n] || '#595959',
              onRemove: function() { this.applyFilters({ natureFilters: natureFilters.filter(function(v) { return v !== n; }) }); }.bind(this),
            });
          }.bind(this));

          if (filters.filterBy !== defaults.filterBy) {
            pills.push({
              key: 'filterBy', label: filters.filterBy ? 'Data: ' + getFilterByLabel(filters.filterBy) : getFilterByLabel(null),
              color: '#1890ff', icon: 'calendar',
              onRemove: function() { persisted.setFilters({ filterBy: defaults.filterBy }); },
            });
          }

          if (search) {
            pills.push({
              key: 'search', label: search, color: '#722ed1', icon: 'search',
              onRemove: function() { persisted.setFilters({ search: '' }); },
            });
          }

                return React.createElement(FilterPillsBar, {
                  pills: pills,
                  onClearAll: filterCount > 0 ? this.handleClearFilters : undefined,
                });
              }.bind(this))()
            }
          />
        </ModuleHeaderWrapper>

        <RestoredFiltersNotice
          visible={persisted.wasRestored}
          onReset={this.handleClearFilters}
          onDismiss={persisted.dismissRestored}
        />

        {!this.state.pendentBannerDismissed && visualizationMode === 'registered' && certificates.pendent.length > 0 && (
        <div style={{
          background: 'linear-gradient(135deg, #fff7e6 0%, #fffbe6 100%)',
          border: '1px solid #ffe58f',
          borderRadius: 8,
          padding: '14px 20px',
          marginTop: 10,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <div style={{
              width: 40, height: 40, borderRadius: '50%',
              background: '#fa8c16',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 2px 8px rgba(250,140,22,0.3)',
            }}>
              <Icon type="file-unknown" style={{ fontSize: 20, color: '#fff' }} />
            </div>
            <div>
              <div style={{ fontWeight: 600, fontSize: 14, color: '#262626', marginBottom: 2 }}>
                {certificates.pendent.length + ' certificado' + (certificates.pendent.length > 1 ? 's' : '') + ' pendente' + (certificates.pendent.length > 1 ? 's' : '') + ' de cadastro'}
              </div>
              <div style={{ fontSize: 13, color: '#595959' }}>
                Certificados que ainda não foram registrados no sistema.
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Button
              size="small"
              onClick={function() {
                this.setState({ pendentDrawerVisible: true });
              }.bind(this)}
              style={{
                background: '#fa8c16',
                borderColor: '#fa8c16',
                color: '#fff', borderRadius: 6, fontWeight: 500,
              }}
            >
              Ver pendentes
            </Button>
            <Icon
              type="close"
              style={{ cursor: 'pointer', color: '#8c8c8c', fontSize: 14, padding: 4 }}
              onClick={function() { this.setState({ pendentBannerDismissed: true }); }.bind(this)}
            />
          </div>
        </div>
        )}

        {this.props.isLoading && (
        <Row gutter={16} style={{ paddingTop: 10 }}>
          <Col span={14}>
            <Card style={{ marginBottom: 10 }} bodyStyle={{ padding: '12px 16px' }}>
              <Skeleton active paragraph={{ rows: 1 }} title={{ width: '40%' }} />
            </Card>
          </Col>
          <Col span={10}>
            <Card style={{ marginBottom: 10 }} bodyStyle={{ padding: '12px 16px' }}>
              <Skeleton active paragraph={{ rows: 1 }} title={{ width: '40%' }} />
            </Card>
          </Col>
        </Row>
        )}

        {!this.props.isLoading && (
        <Row gutter={16} style={{ paddingTop: 10 }}>
          <Col span={14}>
            <Tooltip title={totalTooltip} placement="bottom">
              <Card style={{ marginBottom: 10 }} bodyStyle={{ padding: '12px 16px' }}>
                <Row gutter={16}>
                  <Col span={6}>
                    <Tooltip title={statusTooltip} placement="bottom">
                      <div
                        style={{ cursor: 'pointer' }}
                        onClick={function() { this.applyFilters({ statusFilters: [] }); }.bind(this)}
                      >
                        <Statistic
                          title={<span style={{ fontSize: 12 }}><Icon type="safety-certificate" style={{ marginRight: 4, color: '#1890ff' }} />Total <Icon type="info-circle" style={{ fontSize: 10, opacity: 0.5 }} /></span>}
                          value={stats.totalCount}
                          valueStyle={{ color: '#1890ff', fontSize: 22 }}
                        />
                      </div>
                    </Tooltip>
                  </Col>
                  <Col span={6}>
                    <div
                      style={{ cursor: 'pointer', borderRadius: 4, padding: '0 4px', background: statusFilters.length === 1 && statusFilters[0] === 'Ativo' ? '#f6ffed' : 'transparent', transition: 'background 0.2s' }}
                      onClick={function() { this.applyFilters({ statusFilters: statusFilters.length === 1 && statusFilters[0] === 'Ativo' ? [] : ['Ativo'] }); }.bind(this)}
                    >
                      <Statistic
                        title={<span style={{ fontSize: 12 }}><Icon type="check-circle" style={{ marginRight: 4, color: '#52c41a' }} />Ativos</span>}
                        value={stats.activeCount}
                        valueStyle={{ color: '#52c41a', fontSize: 22 }}
                      />
                    </div>
                  </Col>
                  <Col span={6}>
                    <div
                      style={{ cursor: 'pointer', borderRadius: 4, padding: '0 4px', background: statusFilters.length === 1 && statusFilters[0] === 'Expirando' ? '#fffbe6' : 'transparent', transition: 'background 0.2s' }}
                      onClick={function() { this.applyFilters({ statusFilters: statusFilters.length === 1 && statusFilters[0] === 'Expirando' ? [] : ['Expirando'] }); }.bind(this)}
                    >
                      <Statistic
                        title={<span style={{ fontSize: 12 }}><Icon type="clock-circle" style={{ marginRight: 4, color: '#faad14' }} />Expirando</span>}
                        value={stats.expiringCount}
                        valueStyle={{ color: '#faad14', fontSize: 22 }}
                      />
                    </div>
                  </Col>
                  <Col span={6}>
                    <div
                      style={{ cursor: 'pointer', borderRadius: 4, padding: '0 4px', background: statusFilters.length === 1 && statusFilters[0] === 'Expirado' ? '#fff1f0' : 'transparent', transition: 'background 0.2s' }}
                      onClick={function() { this.applyFilters({ statusFilters: statusFilters.length === 1 && statusFilters[0] === 'Expirado' ? [] : ['Expirado'] }); }.bind(this)}
                    >
                      <Statistic
                        title={<span style={{ fontSize: 12 }}><Icon type="close-circle" style={{ marginRight: 4, color: '#f5222d' }} />Expirados</span>}
                        value={stats.expiredCount}
                        valueStyle={{ color: '#f5222d', fontSize: 22 }}
                      />
                    </div>
                  </Col>
                </Row>
              </Card>
            </Tooltip>
          </Col>
          <Col span={10}>
            <Tooltip title={financeTooltip} placement="bottom">
              <Card style={{ marginBottom: 10 }} bodyStyle={{ padding: '12px 16px' }}>
                <Row gutter={16}>
                  <Col span={8}>
                    <Statistic
                      title={<span style={{ fontSize: 12 }}><Icon type="wallet" style={{ marginRight: 4, color: '#1890ff' }} />Faturado</span>}
                      value={'R$ ' + fmtBRL(stats.totalFaturado)}
                      valueStyle={{ color: '#1890ff', fontSize: 22 }}
                    />
                  </Col>
                  <Col span={8}>
                    <Statistic
                      title={<span style={{ fontSize: 12 }}><Icon type="check-circle" style={{ marginRight: 4, color: '#52c41a' }} />Recebido</span>}
                      value={'R$ ' + fmtBRL(stats.totalRecebido)}
                      valueStyle={{ color: '#52c41a', fontSize: 22 }}
                    />
                  </Col>
                  <Col span={8}>
                    <Statistic
                      title={<span style={{ fontSize: 12 }}><Icon type="exclamation-circle" style={{ marginRight: 4, color: '#faad14' }} />Pendente</span>}
                      value={'R$ ' + fmtBRL(stats.totalPendente)}
                      valueStyle={{ color: '#faad14', fontSize: 22 }}
                    />
                  </Col>
                </Row>
              </Card>
            </Tooltip>
          </Col>
        </Row>
        )}

        <CertificatesTableList
          filteredData={displayData}
          statusFilters={statusFilters}
          typeFilters={typeFilters}
          natureFilters={natureFilters}
          isLoading={isLoading}
          rowSelection={{
            selectedRowKeys: selectedRowKeys,
            onChange: this.onSelectedRowKeysChange,
          }}
          onAction={this.onAction}
          getFilename={this.getFilename}
          visualizationMode={visualizationMode}
          findUser={findUser}
          showEdit={this.props.showEdit}
          totalCount={formattedCertificates.length}
        />

        <SelectionToolbar
          count={selectedRowKeys.length}
          onClear={this.handleClearSelection}
          itemLabel="certificado"
          actions={[
            { label: "Imprimir", icon: "printer", onClick: this.handleBulkPrint },
            { label: "Exportar", icon: "download", onClick: this.exportToExcel },
          ]}
        />

        <Drawer
          title={
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span>
                <Icon type="file-unknown" style={{ color: '#fa8c16', marginRight: 8 }} />
                Certificados Pendentes
                <Badge
                  count={certificates.pendent.length}
                  style={{ backgroundColor: '#fa8c16', marginLeft: 10 }}
                />
              </span>
            </div>
          }
          width={1200}
          placement="right"
          onClose={function() { this.setState({ pendentDrawerVisible: false }); }.bind(this)}
          visible={this.state.pendentDrawerVisible}
          bodyStyle={{ padding: 0 }}
        >
          {this.state.pendentDrawerVisible && certificates.pendent.length > 0 && (
            <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <div style={{ padding: '12px 16px', background: '#fff7e6', borderBottom: '1px solid #ffe58f', fontSize: 13, color: '#ad6800' }}>
                <Icon type="info-circle" style={{ marginRight: 6 }} />
                Certificados aguardando registro. Clique em <strong>Editar</strong> para completar o cadastro.
              </div>
              <div style={{ flex: 1 }}>
                <CertificatesTableList
                  filteredData={certificates.pendent}
                  statusFilters={[]}
                  typeFilters={[]}
                  natureFilters={[]}
                  isLoading={false}
                  rowSelection={{
                    selectedRowKeys: [],
                    onChange: function() {},
                  }}
                  onAction={this.onAction}
                  getFilename={this.getFilename}
                  visualizationMode="pendent"
                  findUser={findUser}
                  showEdit={this.props.showEdit}
                />
              </div>
            </div>
          )}
          {this.state.pendentDrawerVisible && certificates.pendent.length === 0 && (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '80px 20px' }}>
              <Icon type="check-circle" style={{ fontSize: 48, color: '#52c41a', marginBottom: 16 }} />
              <div style={{ fontSize: 16, color: '#595959', fontWeight: 500 }}>Nenhum certificado pendente</div>
              <div style={{ fontSize: 13, color: '#8c8c8c', marginTop: 4 }}>Todos os certificados estão cadastrados.</div>
            </div>
          )}
        </Drawer>
      </div>
    )
  }
}

var mapStateToProps = function(state) {
  return {
    certificates: state.certificates.list,
    isLoading: state.certificates.isLoading,
    customers: state.customers.list.filter(function(row) { return row.enabled === 1 && row.inactived_at === null && row.is_customer; }).sort(function(a, b) { return compare()(a.cod, b.cod); }),
    findUser: function(id) { return state.users.filter(function(r) { return r.id === id; })[0]; },
  };
};

var mapDispatchProps = function(dispatch) {
  return {
    deleteCertificate: function(id) {
      return dispatch({
        type: 'DELETE_CERTIFICATE',
        payload: {
          request: {
            method: 'delete',
            url: '/certificates/' + id,
          }
        },
        id: id
      });
    },
    unArchive: function(id) {
      return dispatch({
        type: 'SAVE_CERTIFICATE',
        payload: {
          request: {
            method: 'put',
            url: '/certificates/' + id + '/unarchive',
          }
        },
        id: id
      });
    },
    saveCertificate: function(data) {
      return dispatch({
        type: 'SAVE_CERTIFICATE_SUCCESS',
        payload: data
      });
    }
  };
};

export default connect(mapStateToProps, mapDispatchProps)(CertificatesList);
